// extracted by css-extract-rspack-plugin
export default {"footnotes":"Footnotes-module__footnotes__xLxvb0s"};